import React, { useCallback, useEffect, useState } from 'react';
import { NumericFormat } from "react-number-format";
import bedIcon from "../../assets/bedIcon.png"
import bathIcon from "../../assets/bathIcon.png"
import axios from 'axios';
import { config } from '../../utils/config';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import { addWatermark } from '../../utils/waterMark';

export default function PropertyListing() {

    const [data, setData] = useState([]);

    const searchPropertyName = useCallback(async (e) => {
        // console.log(e.target.value)
        const response = await axios.get(`${config.apiBaseUrl}/listings/`, {
            params: {
                name: e.target.value
            }
        })
        const propertyListingData = response.data
        // console.log(response.data)
        setData(() => propertyListingData)
    }, [])

    const searchListingType = useCallback(async (e) => {
        // console.log(e.target.value)
        const response = await axios.get(`${config.apiBaseUrl}/listings/`, {
            params: {
                listing: e.target.value
            }
        })
        const propertyListingData = response.data
        // console.log(response.data)
        setData(() => propertyListingData)
    }, [])

    const searchPropertyType = useCallback(async (e) => {
        // console.log(e.target.value)
        const response = await axios.get(`${config.apiBaseUrl}/listings/`, {
            params: {
                type: e.target.value
            }
        })
        const propertyListingData = response.data
        // console.log(response.data)
        setData(() => propertyListingData)
    }, [])

    // const addToCart = useCallback((listingId, price) => {

    //     const quantity = 0
    //     const response = axios.post("http://localhost:3000/cart/add", { listingId, price, quantity }, { withCredentials: true })
    //     console.log(response.data)
    // }, [])



    useEffect(() => {

        const getPropertyData = async () => {
            const response = await axios.get(`${config.apiBaseUrl}/listings/`)
            const propertyListingData = response.data
            console.log(response.data)
            setData(() => propertyListingData)
        }

        // const getAgentData = async () => {


        // }

        getPropertyData()

    }, [])

    return (
        <>
            <div className="container-fluid p-1" style={{ width: "90%" }}>
                {/*Search Bar Start  */}
                <div className="d-flex justify-content-center">
                    <Navbar bg="light" variant="light">
                        <Container>
                            <Nav className="me-auto flex-column flex-md-row">
                                <div className="d-flex justify-content-center mb-3 mb-md-0">
                                    <Form className="d-flex">
                                        <Form.Control
                                            placeholder="Search"
                                            style={{ width: "350px" }}
                                            className="me-2"
                                            aria-label="Search"
                                            type="text"
                                            onChange={searchPropertyName}
                                        />
                                    </Form>
                                </div>
                                <div className="d-flex justify-content-center mb-3 mb-md-0 pe-2">
                                    <Form.Select aria-label="Default select example" onChange={searchListingType}>
                                        <option >Sale/Rent</option>
                                        <option value="For Sale">For Sale</option>
                                        <option value="For Rent">For Rent</option>
                                    </Form.Select>
                                </div>
                                <div className="d-flex justify-content-center pe-2">
                                    <Form.Select aria-label="Default select example" onChange={searchPropertyType}>
                                        <option >Property Type</option>
                                        <option value="HDB">HDB</option>
                                        <option value="Condo">Condo</option>
                                        <option value="Landed">Landed</option>
                                        <option value="Retail">Retail</option>
                                        <option value="Office">Office</option>
                                        <option value="Industrial">Industrial</option>
                                    </Form.Select>
                                </div>
                            </Nav>
                        </Container>
                    </Navbar>

                </div>

                {/* Search Bar End */}
                <h5 className="m-3">{data.length} Property Listings Available</h5>

                <div className='container'>

                    <div className="row row-cols-1 row-cols-md-3 g-4">

                        {data.map((obj) => {
                            return (
                                <div className="col" key={obj.id}>
                                    <div className="card border-light h-100">
                                        <div style={{
                                            overflow: 'hidden',
                                            height: '250px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                            <img src={obj.media[0].media_url} style={{ objectFit: 'cover', width: '100%', height: '100%' }} className="card-img-top" alt="..." />
                                        </div>
                                        <div className="card-body">
                                            {obj.propertyDetails.project_name && obj.propertyDetails.project_name !== "Nil" ? <h5 className="card-title">{obj.propertyDetails.project_name}</h5> :
                                                <h5 className="card-title">{obj.propertyDetails.street_name}</h5>}
                                            <div className="card-img-overlay">
                                                <h5><span className="badge bg-secondary">{obj.listing_sub_type}</span></h5>
                                            </div>

                                            <p className="card-text" style={{ margin: "0", lineHeight: "1.5" }}>{obj.size_land ? null : obj.propertyDetails.block} {obj.propertyDetails.street_name}</p>
                                            <p className="card-text" style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }}>
                                                <NumericFormat className="card-text" prefix={"$"} suffix={""} thousandSeparator={true} value={obj.price} displayType={"text"} />
                                                {" . "}<NumericFormat className="card-text" prefix={"$"} suffix={"psf (floor)"} thousandSeparator={true} value={Math.round(obj.price / obj.size_built)} displayType={"text"} />
                                                {obj.size_land ? <NumericFormat className="card-text" prefix={" . $"} suffix={"psf (land)"} thousandSeparator={true} value={Math.round(obj.price / obj.size_land)} displayType={"text"} /> : null}
                                            </p>
                                            <p className="card-text" style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }}>
                                                {obj.room}{" "}<img src={bedIcon} style={{ width: "20px" }} />
                                                {" " + obj.bath + " "}<img src={bathIcon} style={{ width: "20px" }} />
                                                {" . "}<NumericFormat className="card-text" prefix={""} suffix={"sqft (floor)"} thousandSeparator={true} value={obj.size_built} displayType={"text"} />
                                                {obj.size_land ? <NumericFormat className="card-text" prefix={" . "} suffix={"sqft (land)"} thousandSeparator={true} value={obj.size_land} displayType={"text"} /> : null}
                                            </p>
                                            <p className="card-text" style={{ fontSize: "14px", margin: "0", lineHeight: "3" }}>
                                                <span className="btn btn-outline-danger disabled" style={{ fontSize: "12px", padding: "2px" }}>{obj.propertyDetails.tenure}</span>
                                                {"   "}<span className="btn btn-outline-danger disabled" style={{ fontSize: "12px", padding: "2px" }}>{obj.propertyDetails.property_sub_type}</span>
                                            </p>

                                        </div>
                                        <div className="card-footer" style={{ backgroundColor: "white" }}>
                                            <div className='container'>
                                                <p style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }} className="fw-bold">{obj.agents[0].firstName} {obj.agents[0].lastName}
                                                    <span style={{ fontSize: "13px", margin: "0", lineHeight: "1.5" }} className="fw-normal mx-1">({obj.agents[0].ceaNo})</span></p>
                                                <p style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }} className="fw-normal">Mobile: {obj.agents[0].mobileNo}</p>
                                            </div>

                                            {/* <div className="d-flex justify-content-end">
                                                <button className="btn btn-success btn-sm mx-3" onClick={() => addToCart(obj.id, obj.price)} value="">Add To Cart</button>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div >
        </>
    )
}